class IntersectionHelper {

    constructor() {
        //take a fixed header into consideration
        this.defaultOptions = {
            rootMargin: '-100px 0px 0px 0px'
        }
    }

    enterViewportOnce(element, callback, options = {}) {
        options = {...this.defaultOptions, ...options};
        let observer = new IntersectionObserver((changes, observer) => {
            let change = changes[0];
            if (change.isIntersecting) {
                observer.disconnect();
                callback(change);
            }
        }, options);
        observer.observe(element);
        return observer;
    }

    enterViewport(element, callback, options = {}) {
        options = {...this.defaultOptions, ...options};
        let observer = new IntersectionObserver((changes, observer) => {
            let change = changes[0];
            if (change.isIntersecting) {
                callback(change);
            }
        }, options);
        observer.observe(element);
        return observer;
    }
}

let instance = new IntersectionHelper();
export default instance;



// WEBPACK FOOTER //
// ./app/general/js/intersection-helper.js